import { async } from '@angular/core/testing';
import { ModalService } from './../../services/utils/modal.service';
import { UploadModel, FileModel } from './../../models/upload.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UploadFile } from 'ng-zorro-antd/upload';
import * as Config from 'src/app/config/app.constant';
import { UserModel } from '../../models/user.model';
import { CkeckClaimServiceService } from 'src/app/modules/check-claim-processing/service/ckeck-claim.service.service';
import { UtilsService } from '../../services/utils/utils.service';

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss']
})
export class UploadModalComponent implements OnInit {

  @Input('isVisible') isVisible: Boolean;
  @Input('referenceNo') referenceNo: string;
  @Output() closeModal = new EventEmitter();

  fileList: UploadFile[] = [];
  userData: UserModel;
  docType: string = '1';
  total: number;
  overSize: boolean = false;
  correctFileType: boolean = true;
  isSpinning: boolean = false;
  loading: boolean = false;

  constructor(
    private service: CkeckClaimServiceService,
    public modalService: ModalService,
    public util : UtilsService
  ) {
    this.userData = JSON.parse(sessionStorage.getItem(Config.USER_DETAIL));
  }

  ngOnInit() {

  }

  beforeUpload = (file: UploadFile): boolean => {
    //console.log('beforeUpload ', this.fileList.length);
    let maxSize: number = 0
    if (this.fileList.length > 0) {
      this.fileList.forEach(element => {
        maxSize += element.size;
      });
    }
    maxSize += file.size
    //console.log('maxSize ', maxSize);
    if (maxSize > 10485760) {
      this.overSize = true;
      if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
        this.correctFileType = true;
      } else {
        this.correctFileType = false;
      }
    } else {
      if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
        this.correctFileType = true;
        this.fileList = this.fileList.concat(file);
      } else {
        this.correctFileType = false;
      }
      this.overSize = false;
    }
    //console.log('overSize ', this.overSize);
    return false;
  };

  afterClose(): void {
    this.overSize = false;
  }

  close(): void {
    this.overSize = false;
    this.closeModal.emit(false);
    this.fileList = [];
  }
  genFileBase64(){
    let tmpArray = new Array<FileModel>();
    return new Promise((resolve, reject) => {
      this.fileList.forEach((value, index, array) => {
        let tmp = new FileModel();
        this.util.changeFile(value).then((base64: string): any => {
          tmp.fileData = base64.split(',')[1];
          tmp.fileName = value.name;
          tmpArray.push(tmp);
          if (index === array.length - 1){
            setTimeout(()=>{
            resolve(tmpArray)
            },3000)
          }
        });
      });
    });
  }

  uploadFile(): void {
    //console.log('uploadFile ', this.fileList.length);
    if (this.fileList.length > 0) {
      this.isSpinning = true;
      this.loading = true;
      let tmpArray = new Array<FileModel>();
      var genBase64 = new Promise<void>(async(resolve, reject) => {
        for(let i = 0 ; i < this.fileList.length; i++) {
          let tmp = new FileModel();
          await  this.util.changeFile(this.fileList[i]).then(async(base64: string): Promise<any> => {
            tmp.fileData = base64.split(',')[1];
            tmp.fileName = this.fileList[i].name;
            //console.log('tmp.fileName ', tmp.fileName);
            tmpArray.push(tmp);
        });
        }
        resolve()
      });
      // console.log('before genbase64 ', tmpArray.length);
      // console.log('before genbase64 ', tmpArray);
      genBase64.then(() => {
        let request = new UploadModel();
        request.hospCode = this.userData.customer.hosCode;
        request.fileType = this.docType;
        request.file = tmpArray;
        request.sectionCode = this.referenceNo.slice(0, 2);
        request.orderNo = this.referenceNo.slice(2, 10);
        //console.log('set request ', request);
        this.service.uploadFile(request).subscribe(
          () => {
            this.isSpinning = false;
            this.loading = false;
            this.modalService.success('อัพโหลดสำเร็จ', '');
            this.close();
          }, err => {
            this.isSpinning = false;
            this.loading = false;
            this.modalService.error('อัพโหลดไม่สำเร็จ', '');
            console.log("error -> ", err);
          }
        );
      });
    }
  }

  convertByteToMB(val: string): number {
    let result = parseFloat(val) / 1048576;
    return result;
  }

  deleteUploadFile(index: any): void {
    this.fileList.splice(index, 1);
    this.overSize = false;
    this.correctFileType = true;
  }
}
